class ArticleStockRequest {

    public articleId: string;
    public amount: number;

    constructor(articleId: string, amount: number) {
        this.articleId = articleId;
        this.amount = amount;
    }

}

export default ArticleStockRequest;